import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
    const [blogs, setBlogs] = useState([]);
    const [blog,setBlog] = useState([])
    const [faqs, setFaqs] = useState([]);
    const [privacyPolicy, setPrivacyPolicy] = useState(null);
    const [termsConditions, setTermsConditions] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // API base URL and credentials from .env
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const USERNAME = process.env.REACT_APP_USERNAME;
    const PASSWORD = process.env.REACT_APP_PASSWORD;

    // Axios config with Basic Auth
    const axiosConfig = {
        auth: {
            username: USERNAME,
            password: PASSWORD,
        },
        headers: {
            "Content-Type": "application/json",
        },
    };

    // Generic Fetch Function
    const fetchData = async (endpoint, setter) => {
        setLoading(true);
        try {
            const response = await axios.get(`${SERVER_URL}${endpoint}`, axiosConfig);
            setter(response.data);
        } catch (err) {
            setError(err.message);
            console.error(`Error fetching ${endpoint}:`, err);
        } finally {
            setLoading(false);
        }
    };

    // Fetch Blogs
    const fetchBlogs = () => fetchData("api/blogs/", setBlogs);

    // Fetch FAQs
    const fetchFaqs = () => fetchData("api/faqs", setFaqs);

    // Fetch Privacy Policy
    const fetchPrivacy = () => fetchData("api/privacy-policy/", setPrivacyPolicy);

    // Fetch Terms & Conditions
    const fetchTerms = () => fetchData("api/terms-and-conditions/", setTermsConditions);

    // Fetch All Data on Mount (optional)
    const fetchBlogByUrl = async (url_title) => {
        setLoading(true);
        try {
            const response = await axios.get(`${SERVER_URL}api/blogs/${url_title}`, axiosConfig);
            setBlog(response.data);
        } catch (err) {
            setError(err.message);
            console.error(`Error fetching blog url_title ${url_title}:`, err);
        } finally {
            setLoading(false);
        }
    };
    return (
        <DataContext.Provider value={{
            blogs, faqs, privacyPolicy, termsConditions,
            loading, error, fetchBlogs, fetchFaqs, fetchPrivacy, fetchTerms,fetchBlogByUrl,blog}}>
            {children}
        </DataContext.Provider>
    );
};

// Custom Hook for using DataContext
export const useDataContext = () => useContext(DataContext);
